module.exports = __webpack_public_path__ + "static-portal/img/61.3da93c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/61.jpg
// module id = ZIVH
// module chunks = 4